<div class="rounded-2xl bg-white h-full"
     [class]="variantClass"
     [class.selected]="selected">
    <ng-content></ng-content>
</div>
